module.exports = __webpack_public_path__ + "img/oem8.f843c271.png";